import { BoundSelectField, BoundSelectFieldProps } from "@homebound/beam";
import { useMemo } from "react";
import {
  ChangeEventReasonsDataFragment,
  useChangeEventReasonsQuery,
} from "src/components/autoPopulateSelects/ChangeEventReasonsSelectField.generated";
import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { filterArchivedUnlessSelected } from "src/utils/changeEventReasons";

type ChangeEventReasonsFieldProps = Omit<
  BoundSelectFieldProps<ChangeEventReasonsDataFragment, string>,
  "options" | "multiselect" | "getOptionLabel" | "getOptionValue"
> & {
  getOptionLabel?: (o: ChangeEventReasonsDataFragment) => string;
  getOptionValue?: (o: ChangeEventReasonsDataFragment) => string;
  // Optional in-memory filter by workflow
  workflow?: ChangeEventWorkflow;
};

export function ChangeEventReasonsBoundSelectField(props: ChangeEventReasonsFieldProps) {
  const {
    placeholder = "Select a change event reason",
    getOptionLabel = (o) => o.name,
    getOptionValue = (o) => o.id,
    workflow,
    ...otherProps
  } = props;
  const { data, loading } = useChangeEventReasonsQuery({ fetchPolicy: "cache-first" });
  const options = useMemo(
    () =>
      filterArchivedUnlessSelected(data?.changeEventReasons, otherProps.field.value).filter((r) =>
        workflow ? r.workflows.includes(workflow) : true,
      ),
    [data, otherProps.field.value, workflow],
  );

  return (
    <BoundSelectField
      {...otherProps}
      placeholder={loading ? "Loading..." : placeholder}
      options={options}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
    />
  );
}
